//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const styles = {
  card: {
    //maxWidth: 1030
  },
  media: {
    // ⚠️ object-fit is not supported by IE 11.
    objectFit: 'cover',
  },
};


//'url(' + require('../../images/IMG_1.JPG')
class TextTowAgent extends React.Component {
  
  constructor(props) {
    super(props);
    
  }
  
  render() {
    const {classes} = this.props;
    return (
      < Card className = {classes.card} >
        < CardActionArea >
          
          < CardContent >
            < Typography
              variant = "h5"
              component = "h2"  style={{ display: 'inline-block',   fontSize:32,  color: 'black', width:1000 }}>
              Texting Tow Agent Page
            < /Typography>
            <br/>
            <br/>
            < Typography
              component = "p" style={{ display: 'inline-block',   fontSize:30,  color: 'black', width:1000 }}>
              This is to text the Tow Agent directly.
            < /Typography>
            < Typography
              component = "p" style={{ display: 'inline-block',   fontSize:30,  color: 'black', width:1000 }}>
              This feature will be added in future.
            < /Typography>
          < /CardContent>
        < /CardActionArea>
      
      < /Card>
    )
      ;
  }//end of render
}//End of class

TextTowAgent.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TextTowAgent);
